// Hero road + arrow visual inspired by the Wosol Tech logo:
// a perspective road converging upward into a glowing arrow.
export default function RoadVisual() {
  return (
    <div
      className="absolute inset-0 pointer-events-none overflow-hidden"
      aria-hidden="true"
      data-testid="hero-road-visual"
    >
      {/* perspective grid */}
      <div
        className="absolute inset-0 opacity-60"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0,240,255,0.18) 1px, transparent 1px), linear-gradient(90deg, rgba(0,240,255,0.18) 1px, transparent 1px)",
          backgroundSize: "80px 80px",
          transform: "perspective(900px) rotateX(62deg) translateY(28%)",
          transformOrigin: "center top",
          maskImage:
            "radial-gradient(ellipse at 50% 30%, black 0%, transparent 70%)",
          WebkitMaskImage:
            "radial-gradient(ellipse at 50% 30%, black 0%, transparent 70%)",
        }}
      />

      {/* radial halo */}
      <div className="absolute inset-0 wt-vignette" />

      {/* center road + arrow SVG */}
      <svg
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        width="900"
        height="900"
        viewBox="0 0 900 900"
        fill="none"
      >
        <defs>
          <linearGradient id="road-grad" x1="450" y1="900" x2="450" y2="0" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#00F0FF" stopOpacity="0" />
            <stop offset="0.45" stopColor="#00F0FF" stopOpacity="0.55" />
            <stop offset="1" stopColor="#00F0FF" stopOpacity="1" />
          </linearGradient>
          <linearGradient id="blade-grad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#E2E8F0" stopOpacity="0.8" />
            <stop offset="1" stopColor="#0A1428" stopOpacity="0" />
          </linearGradient>
          <radialGradient id="arrow-glow" cx="0.5" cy="0.5" r="0.5">
            <stop offset="0" stopColor="#00F0FF" stopOpacity="0.9" />
            <stop offset="1" stopColor="#00F0FF" stopOpacity="0" />
          </radialGradient>
        </defs>

        {/* W blades — left & right */}
        <path
          d="M 220 760 L 360 200 L 410 360 L 450 220"
          stroke="url(#blade-grad)"
          strokeWidth="2"
          fill="none"
          opacity="0.7"
        />
        <path
          d="M 680 760 L 540 200 L 490 360 L 450 220"
          stroke="url(#blade-grad)"
          strokeWidth="2"
          fill="none"
          opacity="0.7"
        />

        {/* the road — converging trapezoid */}
        <path
          d="M 360 760 L 540 760 L 470 200 L 430 200 Z"
          fill="url(#road-grad)"
          opacity="0.35"
        />

        {/* road center dashed line */}
        <line
          x1="450"
          y1="760"
          x2="450"
          y2="220"
          stroke="#00F0FF"
          strokeWidth="2"
          className="wt-dash"
          opacity="0.9"
        />

        {/* glow under arrow */}
        <circle cx="450" cy="180" r="120" fill="url(#arrow-glow)" />

        {/* upward arrow */}
        <g className="wt-arrow-glow">
          <path
            d="M 450 110 L 410 200 L 440 200 L 440 250 L 460 250 L 460 200 L 490 200 Z"
            fill="#00F0FF"
          />
        </g>
      </svg>

      {/* faint scanline overlay */}
      <div
        className="absolute inset-0 mix-blend-screen opacity-[0.06]"
        style={{
          backgroundImage:
            "repeating-linear-gradient(180deg, rgba(0,240,255,0.6) 0 1px, transparent 1px 3px)",
        }}
      />
    </div>
  );
}
